class UserInputFormatter {
  formatField = (field, input) => {
    switch (field) {
      case 'vimeo_url':
        return this.convertVimeoInputToUid(input)
      case 'zoom_uid':
        return this.convertZoomInputToUid(input)
      default:
        return input;
    }
  }

  convertVimeoInputToUid = (input) => {
    return ((`${input}` || '').replace(/[\s]/g, '').match(/\d{5,}/) || [])[0] || input
  }

  convertZoomInputToUid = (input) => {
    return ((`${input}` || '').replace(/[\s-]/g, '').match(/\d{5,}/) || [])[0] || input
  }
}

export default (new UserInputFormatter())



/** WEBPACK FOOTER **
 ** ./src/services/userInputFormatter.js
 **/